module.exports = __webpack_public_path__ + "img/icon-social-twitter-white.da4f2fb0.svg";